// import all translations

import { peInstance } from '@/classes-shared/utils/axiosInstance'
import availableTranslations from './translations'

export default class LanguageInjector {
  static async injectAllLanguages() {
    try {
      /* global axios store */
      // loading external language file
      const { data } = await peInstance().get('/translations')

      // iterate available application languages
      for (let [key, value] of Object.entries(availableTranslations)) {
        // add new external Translations (exTrans)
        i18n.mergeLocaleMessage(key, data[key])
      }
      store.commit('setExtTransLoaded')
      return Promise
    } catch (error) {
      return Promise
    }
  }
}
